import { FC } from "react";

import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import ListItem from "@mui/material/ListItem";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";

import CloseDialogIcon from "../../../common/components/icons/CloseDialogIcon";

const CONTACT_PERSON = {
  email: "sales@cleanconnect.ai",
};

interface IContactsDialogProps {
  open: boolean;
  handleClose: () => void;
  preventUpload?: (state: boolean) => void;
  runOutText?: string;
  name?: string;
  mobileNumber?: string;
  email?: string;
}

const ContactsDialog: FC<IContactsDialogProps> = ({
  runOutText,
  open,
  handleClose,
  preventUpload,
  email = CONTACT_PERSON.email,
}) => {
  const handleEmailClick = () => {
    if (preventUpload) preventUpload(true);
  };

  const handleCloseClick = () => {
    if (preventUpload) preventUpload(false);

    handleClose();
  };

  return (
    <Dialog
      maxWidth="sm"
      open={open}
      onClose={handleCloseClick}
      sx={{
        "& .MuiPaper-root": {
          padding: "2em 3em",
          borderRadius: "12px",
        },
      }}
    >
      <DialogTitle textAlign="center">
        <Typography variant="h4" component="div" fontSize="26px">
          {`${runOutText} Contact sales team to get unlimited access.`}
        </Typography>
      </DialogTitle>
      <CloseDialogIcon onClose={handleCloseClick} />
      <DialogContent>
        <Box
          sx={{
            padding: "1.5em",
            borderRadius: "8px",
            border: theme => `1px solid ${theme.palette.otherDivider.main}`,
            backgroundColor: theme => theme.palette.otherBackground.main,
          }}
        >
          <Table
            sx={{
              ".MuiTableCell-root": {
                border: "none",
                pt: "0.5em",
                pb: "0.5em",
              },
              ".MuiTableCell-head": {
                paddingLeft: 0,
              },
            }}
          >
            <TableBody>
              <TableRow>
                <TableCell variant="head">
                  <Typography
                    variant="subtitle2"
                    sx={{
                      color: "otherTextTertiary.main",
                    }}
                  >
                    EMAIL
                  </Typography>
                </TableCell>
                <TableCell>
                  <ListItem
                    disablePadding
                    key="Email"
                    component="a"
                    href={`mailto:${email}`}
                    onClick={handleEmailClick}
                  >
                    <Typography
                      variant="subtitle1"
                      sx={{
                        color: "text.primary",
                        textDecoration: "underline",
                      }}
                    >
                      {email}
                    </Typography>
                  </ListItem>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ContactsDialog;
